
export type UserDefineState = {
    platformId : string
}

export class UserDefine {
    public state: UserDefineState;

    constructor() {
        this.state = {
            platformId:''
        };
    }



}

export const userDefine = new UserDefine();

// @ts-ignore
window.userdefine = userDefine;